import * as Phaser from "phaser-ce"
import { Scale } from "../utils/Scale"
import { Sprites } from "../utils/Sprites"
import { GenericAssets } from "./GenericAssets"

export class VapeSprite extends Phaser.Sprite {

    private vapeAnim: Phaser.Animation
    private vapeTimer: Phaser.Timer

    constructor(game: Phaser.Game, x: number, y: number, reversed = false, scale = 1, group?: Phaser.Group) {
        super(game, x, y, reversed ? GenericAssets.VAPE_SMOKE_REVERSED : GenericAssets.VAPE_SMOKE)

        if (group) {
            group.add(this)
        } else {
            game.add.existing(this)
        }
        Scale.scaleSprite(this, scale)

        this.vapeAnim = this.animations.add("vape")
        this.vapeAnim.onComplete.add(() => {
            Sprites.fade(this, {fadeIn: false, fadeDuration: 2000})
        })

        this.alpha = 0
    }

    vapeLoop = (delay = 6000) => {
        this.vape()
        this.vapeTimer = this.game.time.create()
        this.vapeTimer.loop(delay, () => {
            this.vape()
        })
        this.vapeTimer.start()

    }

    vape = () => {
        this.frame = 0
        this.alpha = 1
        this.vapeAnim.play(8)
    }

    stopVaping = () => {
        if (this.vapeTimer) {
            this.vapeTimer.stop()
        }
        this.animations.stop()
        this.animations.frame = 0
        this.alpha = 0
    }
}
